import api from './api';

// 데이터베이스 API 함수들
const databaseApi = {
  // 데이터베이스 연결 테스트
  testConnection: async (connectionData) => {
    const response = await api.post('/database/test-connection', connectionData);
    return response.data;
  },
  
  // 데이터베이스 연결 생성
  createConnection: async (connectionData) => {
    const response = await api.post('/database/connections', connectionData);
    return response.data;
  },
  
  // 데이터베이스 연결 목록 가져오기
  listConnections: async () => {
    const response = await api.get('/database/connections');
    return response.data;
  },
  
  // 데이터베이스 연결 정보 가져오기
  getConnection: async (connectionId) => {
    const response = await api.get(`/database/connections/${connectionId}`);
    return response.data;
  },
  
  // 데이터베이스 연결 삭제
  deleteConnection: async (connectionId) => {
    const response = await api.delete(`/database/connections/${connectionId}`);
    return response.data;
  },
  
  // 데이터베이스 테이블 목록 가져오기
  listTables: async (connectionId) => {
    const response = await api.get(`/database/connections/${connectionId}/tables`);
    return response.data;
  },
  
  // 쿼리 실행
  executeQuery: async (queryData) => {
    const response = await api.post('/database/query', queryData);
    return response.data;
  },
  
  // 쿼리 상태 확인
  getQueryStatus: async (queryId) => {
    const response = await api.get(`/database/query/${queryId}`);
    return response.data;
  },
  
  // 쿼리 결과 가져오기 
  getQueryResult: async (queryId) => {
    const response = await api.get(`/database/query/${queryId}/result`);
    return response.data;
  },
  
  // 쿼리 목록 가져오기
  listQueries: async () => {
    try {
      const response = await api.get('/database/queries');
      return response.data;
    } catch (error) {
      // 쿼리 목록 API가 아직 구현되지 않은 경우 빈 배열 반환
      console.warn('쿼리 목록 API가 구현되지 않았습니다:', error);
      return { queries: [] };
    }
  }
};

export default databaseApi; 